import { RepoStoreFocusType, useRepoStore } from '../../../repo-store'

export const useFocus = (readOnly: boolean) => {
  const setFocus = useRepoStore((s) => s.setFocus)

  return ({
    blockId,
    type = 'block:wrapper',
  }: {
    type?: RepoStoreFocusType
    blockId: string
  }) => {
    if (readOnly) return
    if (!setFocus) return
    setFocus({ type, blockId })
  }
}
